<script lang="ts" setup>
import type { MetadataFragment } from '~/lib/graphql/graphql.ts'
import { getFeaturedImageUrl } from '~/lib/utils.ts'

const route = useRoute()

const client = useBoscaClient()
const article = await client.content.getContent(route.params.slug.toString())

useHead({ title: article?.name })

useSeoMeta({
    title: article?.name,
    ogTitle: article?.name,
    description: article?.attributes['description'],
    ogDescription: article?.attributes['description'],
    ogImage: getFeaturedImageUrl(article as MetadataFragment),
    ogUrl: 'https://passionequip.com/articles/' + route.params.slug,
})
</script>

<template>
  <PageContent
    v-if="article"
    disable-top-padding
  >
    <ContentItemHeader :item="article" />
    <article class="prose prose-xl dark:prose-invert pt-3 py-4 m-auto">
      <ContentMedia
        :item="article"
        class="px-2 my-6"
      />
      <ContentControls
        class="px-4"
        :item="article"
      />
      <div class="mx-4">
        <ContentDocument :item="article as MetadataFragment" />
      </div>
      <hr class="mt-8 mb-8">
      <ContentAuthor :item="article" />
    </article>
  </PageContent>
</template>
